export default "__VITE_ASSET__DFmdUTms__"